import { connect } from "react-redux";
import BookingBannerPlaceholder from "app/pages/Booking/BookingBannerPlaceholder/BookingBannerPlaceholder";
import {
	checkForSpecialOffer,
	checkSpecialOfferForSelectedDepartureDate,
} from "app/pages/Booking/Payment/paymentSelector";
import { withRouter } from "react-router-dom";

const mapStateToProps = (state, ownProps) => {
	const { location } = ownProps;

	const shouldConsiderFlightSpecialOffer = ["payment", "quote", "detail"].find(page => {
		return location.pathname.includes(page);
	});

	return {
		specialOffer: state.ficheProduit.specialOffer,
		fallBackSpecialOffer: state.partner.fallbackSpecialOffer,
		isSpecialOfferActive: shouldConsiderFlightSpecialOffer
			? checkForSpecialOffer(state)
			: checkSpecialOfferForSelectedDepartureDate(state),
	};
};

export default withRouter(connect(mapStateToProps)(BookingBannerPlaceholder));
